import { render, staticRenderFns } from "./MStoreSavedSearches.vue?vue&type=template&id=1d2b36d0&scoped=true&"
import script from "./MStoreSavedSearches.vue?vue&type=script&lang=ts&"
export * from "./MStoreSavedSearches.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreSavedSearches.vue?vue&type=style&index=0&id=1d2b36d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b36d0",
  null
  
)

export default component.exports